import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { addSingleCondition } from 'actions/feature/conditions'
import {
  getNewOutputNodeIndex,
  getSingleConditionMetaData,
} from 'selectors/feature/outputs'
import { getLogicNodesMetaByFunction } from 'selectors/feature/logicNodes'
import { getFunctionOutputs } from 'selectors/feature/functions'
import { getFeatureModuleType } from 'selectors/feature/featureMetadata'
import {
  ANALOG_INPUT,
  NATIVE_INPUT,
  DIGITAL_INPUT,
  CAN_INPUT,
} from 'utils/constants'
import FunctionNavList from './FunctionNavList'

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps
  const outputs = getFunctionOutputs(state, { id }) || []
  const logicNodes = getLogicNodesMetaByFunction(state, { id })

  const [firstOutput] = outputs

  const singleCondition = firstOutput
    ? getSingleConditionMetaData(state, firstOutput)
    : {}

  const { isSingleConditionOutput, isSixteenBitCan } = singleCondition

  const moduleType = getFeatureModuleType(state)
  const newOutputNodeIndex = getNewOutputNodeIndex(state)

  return {
    outputs,
    logicNodes,
    moduleType,
    newOutputNodeIndex,
    isSingleConditionOutput,
    isSixteenBitCan,
    singleCondition,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      addSingleCondition,
    },
    dispatch
  ),
})

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => {
  const { id } = ownProps

  const { isSixteenBitCan, ...restFromState } = propsFromState

  const { addSingleCondition: dispatchAddSingleCondition } = propsFromDispatch

  return {
    ...ownProps,
    ...restFromState,
    isSixteenBitCan,
    addAnalogInput: () =>
      dispatchAddSingleCondition(ANALOG_INPUT, id, isSixteenBitCan),
    addDigitalInput: () =>
      dispatchAddSingleCondition(DIGITAL_INPUT, id, isSixteenBitCan),
    addNativeInput: () =>
      dispatchAddSingleCondition(NATIVE_INPUT, id, isSixteenBitCan),
    addCanInput: () =>
      dispatchAddSingleCondition(CAN_INPUT, id, isSixteenBitCan),
  }
}

const FunctionEditorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(FunctionNavList)

export default FunctionEditorContainer
